import { combineReducers } from "redux";
import article from "./article";
import banner from "./banner";
//import category from "./category";

//合并领域模型
const rootReducer = combineReducers({
    article,
    banner,
    module
})

export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/modules/entities/index.js